<template>
    <div class="payable-receivable-mark-container">
        <Loading v-if="loading" />

        <div v-else>
            <Select title="Categoria" field="category" :formName="formName"
                url="api/v1/finance/chart-of-accounts/select-all" :propsParams="{ any: typeCostCenter }"
                v-model="payableReceivableMark.chartOfAccounts" :showNewRegister="false">
            </Select>

            <Select title="Tipo de Pagamento" field="typePayment" :formName="formName"
                placeholder="Selecione o tipo de pagamento" v-model="payableReceivableMark.typePayment"
                url="/api/v1/finance/type-payment/select-all" nameNewRegister="typePaymentCreateUpdate"
                titleNewRegister="Tipo de Pagamento" :widthNewRegister="500" :heightNewRegister="250">
                <TypePaymentCreateUpdate :registerInSelect="true" v-model="payableReceivableMark.typePayment" />
            </Select>
            <Select title="Conta Bancária" field="bankAccount" :formName="formName"
                placeholder="Selecione a conta bancária" v-model="payableReceivableMark.bankAccount"
                url="api/v1/finance/bank-account/select-all" :showNewRegister="false">
            </Select>
            <DateTime v-model="payableReceivableMark.conciliationDate" :title="'Data de Conciliação'"
                field="conciliationDate" :formName="formName" :format="'DD/MM/YYYY'"
                :placeholder="'Selecione a data de conciliação'" />
        </div>
    </div>
</template>

<script>
import DateTime from "@/ui/forms/DateTime";
import Select from "@/ui/forms/Select";
import Loading from "@/ui/shared/Loading.vue";
import TypePaymentCreateUpdate from "@/modules/finance/components/typePayment/TypePaymentCreateUpdate.vue";

import PayableReceivableService from "../../services/payableReceivable.service.js";
import { getPayableReceivableTypeCostCenter } from "../../services/payableReceivableList.config";

import { mapState } from "vuex";

export default {
    name: "PayableReceivableMark",
    components: {
        DateTime,
        Select,
        Loading,
        TypePaymentCreateUpdate,
    },
    data() {
        return {
            formName: "payableReceivableMarkForm",
            loading: false,
            type: null,
            payableReceivableMark: {
                conciliationDate: "",
                chartOfAccounts: { id: "", content: "" },
                typePayment: { id: "", content: "" },
                bankAccount: { id: "", content: "" },
            },
        };
    },
    mounted() {
        this.loadRecord();
    },
    computed: {
        ...mapState("generic", ["selected"]),
        selectedId() {
            return this.selected[0];
        },
        typeCostCenter() {
            return getPayableReceivableTypeCostCenter(this.type);
        },
    },
    methods: {
        async loadRecord() {
            const id = this.selectedId;
            if (!id) return;

            this.loading = true;
            const response = await PayableReceivableService.getAllPartialPayment(id);
            if (response.success) {
                const payableReceivable = response.content.payableReceivable || {};

                this.type = payableReceivable.type ?? null;
                this.payableReceivableMark.chartOfAccounts = payableReceivable.chartOfAccounts?.id
                    ? { id: payableReceivable.chartOfAccounts.id, content: payableReceivable.chartOfAccounts.content }
                    : { id: "", content: "" };
                this.payableReceivableMark.typePayment = payableReceivable.typePayment?.id
                    ? { id: payableReceivable.typePayment.id, content: payableReceivable.typePayment.content }
                    : { id: "", content: "" };
                this.payableReceivableMark.bankAccount = payableReceivable.bankAccount?.id
                    ? { id: payableReceivable.bankAccount.id, content: payableReceivable.bankAccount.content }
                    : { id: "", content: "" };
            }
            this.loading = false;
        },
    },
    watch: {
        payableReceivableMark: {
            handler(value) {
                this.$emit("input", value);
            },
            deep: true,
            immediate: true,
        },
    },
};
</script>

<style scoped>
.payable-receivable-mark-container {
    gap: 8px;
    padding: 4px 0;
}
</style>